import React, { Component } from 'react';

import { agreeToTerms } from '../../../redux/actions/userAction';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import AdminUser from './AdminUser';
import SubUser from './SubUser';
import TermsContent from '../../Content/MyDPContent';
import RaisedButton from 'material-ui/RaisedButton';

class TermsAndConditions extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        //this.props.updateHeaderTitle('Voorwaarden');
        //this.props.pushTitleResetHistory("Voorwaarden", '/terms-and-conditions');
    }

    renderContentFile(object, key) {
        
        return(
            <span key={key}>
                <strong>{object.title}</strong>
                <p style={{marginBottom: 15}}>{object.content}</p>
            </span>
        )
    }

    render() {
        return (
            <div className="pagecontent pagecontent--padded pagecontent--full">
                <div className="card card--margin-top-10" >
                    <div style={{padding: 25}}>
                        <TermsContent />
                        <RaisedButton
                            onClick={() => this.props.agreeToTerms(this.props.clientPath + '/api/user/action/agree', this.props.user.user_id)}
                            label="Akkoord"
                            primary={true}
                            fullWidth={false}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        agreeToTerms: (url, user_id) => dispatch(agreeToTerms(url, user_id)),
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions));



// WEBPACK FOOTER //
// ./src/components/Application/TermsAndConditions/index.js